// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modalContainer___XEx7r{max-height:832px;width:572px}.modalContainer___XEx7r .historyCardsWrapper___mDCVo{padding:12px 0 20px}\n", "",{"version":3,"sources":["webpack://./src/components/RevisionHistoryModal/RevisionHistoryModal.css"],"names":[],"mappings":"AAAA,wBACI,gBAAA,CACA,WAAA,CAGA,qDALJ,mBAAA","sourcesContent":[".modalContainer {\n    max-height: 832px;\n    width: 572px;\n}\n\n    .modalContainer .historyCardsWrapper {\n        padding: 12px 0 20px 0;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": "modalContainer___XEx7r",
	"historyCardsWrapper": "historyCardsWrapper___mDCVo"
};
export default ___CSS_LOADER_EXPORT___;
